export const GET_DATA_CLIENTS_EXECUTIVES           = 'GET_DATA_CLIENTS_EXECUTIVES'
export const GET_DATA_CLIENTS_EXECUTIVES_CLONE     = 'GET_DATA_CLIENTS_EXECUTIVES_CLONE'
export const DATA_CLIENT_EXECUTIVE                 = 'DATA_CLIENT_EXECUTIVE'
export const GET_DATA_MASTER_CLIENTS_EXECUTIVES    = 'GET_DATA_MASTER_CLIENTS_EXECUTIVES'
export const LOADING_DATA_CLIENTS_EXECUTIVES       = 'LOADING_DATA_CLIENTS_EXECUTIVES'